export default {
  hasPendingAjax: state => state.loadingCount > 0,
}
